import { INoteTagsByUserQuery } from '@rhizome/pgtypes';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useFetcher } from '../../utils/DataFetchers';
import { DefaultButton } from '../DefaultButton';

function PageFilters(props: {
  published: boolean | null;
  setPublished: any;
  title: string | null;
  setTitle: any;
  selectedTags: Set<string>;
  setSelectedTags: any;
  open: boolean;
}) {
  const [searchField, setSearchField] = useState('');
  const { data: noteTags } = useFetcher<INoteTagsByUserQuery>(
    [
      'NoteTagsByUser',
      {
        tags: Array.from(props.selectedTags),
      },
    ],
    {}
  );

  const filteredTags = noteTags?.filter((tag) => {
    // if the tag has no references, don't show it
    if (tag.count === 0) {
      return false;
    }
    if (tag?.tag?.toLowerCase().includes(searchField.toLowerCase())) {
      return true;
    }
  });

  const tags = filteredTags?.map((tag, index) => {
    return (
      <TagButton
        key={index}
        selected={props.selectedTags.has(tag?.tag || '')}
        onClick={() => {
          const newSet: Set<string> = new Set(props.selectedTags);
          if (!props.selectedTags.has(tag?.tag || '')) {
            newSet.add(tag?.tag || '');
          } else {
            newSet.delete(tag?.tag || '');
          }
          props.setSelectedTags(newSet);
          setSearchField('');
        }}
      >
        {tag?.tag}
      </TagButton>
    );
  });

  // effects and logic

  //   // refetch the excerpts and tags when selected tags change.
  //   useEffect(() => {
  //     refetchNoteTags({ overlappingTags: Array.from(props.selectedTags) });
  //   }, [props.selectedTags]);

  return (
    <>
      {props.open ? (
        <PageFilterMenu>
          <div>
            published:
            <input
              name="published"
              type="checkbox"
              checked={props.published || false}
              onChange={() => {
                props.setPublished(!props.published);
              }}
            />
          </div>
          <div>
            title:
            <input
              type="text"
              value={props.title || ''}
              onChange={(evt) => {
                props.setTitle(evt.target.value);
              }}
            />
          </div>
          <div>
            <div>tags:</div>
            <input
              name="username"
              value={searchField}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                if (evt.target !== null) setSearchField(evt.target.value);
              }}
              autoComplete="off"
              placeholder="search for a tag..."
              style={{
                marginRight: '7px',
              }}
            />
            {searchField === '' ? null : (
              <DefaultButton
                onClick={() => {
                  setSearchField('');
                }}
              >
                x
              </DefaultButton>
            )}
            {props.selectedTags.size > 0 ? (
              <DefaultButton
                onClick={() => {
                  props.setSelectedTags(new Set());
                }}
                style={{
                  marginRight: '7px',
                }}
              >
                clear selected
              </DefaultButton>
            ) : null}
            <TagsContainer>{tags}</TagsContainer>
          </div>
        </PageFilterMenu>
      ) : null}
    </>
  );
}
const PageFilterMenu = styled.div`
  border-radius: 0.2rem;
  margin-bottom: 15px;
  padding: 1vw;
  margin: 0vw 2vw 0vw 0vw;
  background-color: ${(props) => props.theme.colors.main.light};
`;

const TagsContainer = styled.div`
  overflow-y: scroll;
  max-height: 150px;
`;

const TagButton = styled.button<{ selected: boolean }>`
  border-radius: 0.2rem;
  font-size: 12px;
  margin: 1.5px 3px 3px 1.5px;
  padding: 2px;
  border: none;

  background-color: ${(props) =>
    props.selected
      ? props.theme.colors.main.dark
      : props.theme.colors.main.medium};
  color: black;
`;

export default PageFilters;
